import { render } from "./truckStatistics.vue?vue&type=template&id=74bb62f1&scoped=true"
import script from "./truckStatistics.vue?vue&type=script&lang=js"
export * from "./truckStatistics.vue?vue&type=script&lang=js"

import "./truckStatistics.vue?vue&type=style&index=0&id=74bb62f1&lang=scss&scoped=scoped"
import "./truckStatistics.vue?vue&type=style&index=1&id=74bb62f1&scoped=true&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74bb62f1"]])

export default __exports__